export const ContentHeaderFooterServiceMocks = {
  triggerLoginModal: [
    {
      appName: 'homepage',
      showLoginModal: 'false'
    },
    {
      appName: 'shoplite-2',
      showLoginModal: 'true'
    },
    {
      appName: 'checkout',
      showLoginModal: 'true'
    },
    {
      appName: 'home',
      showLoginModal: 'true'
    },
    {
      appName: 'flight-status',
      showLoginModal: 'true'
    },
    {
      appName: 'edocs',
      showLoginModal: 'true'
    },
    {
      appName: 'static',
      showLoginModal: 'true'
    },
    {
      appName: 'bau',
      showLoginModal: 'true'
    },
    {
      appName: 'flyready',
      showLoginModal: 'true'
    },
    {
      appName: 'nextgencko',
      showLoginModal: 'true'
    },
    {
      appName: 'nextgencancel',
      showLoginModal: 'true'
    },
    {
      appName: 'nextgencanceltrip',
      showLoginModal: 'true'
    }
  ]
};
